module.exports = __webpack_public_path__ + "img/wf-finishing-position-14.e747a5b0.svg";